import { useNavigate } from "react-router-dom";
import "../styles/Home.css"; // Reaproveita as variáveis de estilo

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-wrapper">
      {/* Hero Section */}
      <header className="home-hero">
        <div className="hero-content">
          <h1>Sistema de Gestão de Arquivos</h1>
          <p className="hero-subtitle">
            A solução inteligente para organizar departamentos, gerenciar pastas 
            e compartilhar documentos com total segurança.
          </p>
          
          <div className="home-actions">
            <button 
              className="btn home-btn-primary" 
              onClick={() => navigate("/register")}
            >
              Começar Agora (Grátis)
            </button>
            <button 
              className="btn home-btn-secondary" 
              onClick={() => navigate("/login")}
            >
              Acessar minha conta
            </button>
          </div>
        </div>
      </header>

      {/* Seção de Features */}
      <section className="home-features">
        <div className="feature-card">
          <div className="feature-icon">🏢</div>
          <h3>Departamentos</h3>
          <p>Separe seus documentos por setores da empresa de forma organizada.</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">👥</div>
          <h3>Compartilhamento</h3>
          <p>Conceda acesso a outros usuários via e-mail em apenas um clique.</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">🔒</div>
          <h3>Segurança</h3>
          <p>Seus dados protegidos por autenticação JWT e controle de permissões.</p>
        </div>
      </section>

      <footer className="home-footer">
        <p>&copy; 2026 SGA - Todos os direitos reservados.</p>
      </footer>
    </div>
  );
}

export default Home;